export function intersects<T>(a: T[], b: T[]): boolean {
  const setA = new Set(a)
  return b.some((item) => setA.has(item))
}
